import { LocationOn, Warehouse, Storefront } from "@mui/icons-material";
import { Box, Tooltip, Avatar } from "@mui/material";
import { Handle, Position } from "reactflow";
import { LocationType } from "./lebanon-map";

export const CustomNode: React.FC<any> = ({ data }) => {
    const { id, label, color = "primary", onClick, type, logoUrl} = data;
    
    // Render logo if available
    const renderIcon = () => {
      // Shop with logo
      if (type === LocationType.SHOP && logoUrl) {
        return (
          <Avatar 
            src={logoUrl} 
            alt={label}
            sx={{ 
              width: 32, 
              height: 32, 
              border: '2px solid #f44336',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}
          >
            <Storefront fontSize="small" color="error" />
          </Avatar>
        );
      }
      
      // Warehouse with logo (organization logo)
      if (type === LocationType.WAREHOUSE && logoUrl) {
        return (
          <Avatar 
            src={logoUrl} 
            alt={label}
            sx={{ 
              width: 32, 
              height: 32, 
              border: '2px solid #1976d2',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}
          >
            <Warehouse fontSize="small" color="primary" />
          </Avatar>
        );
      }
      
      // Default icons
      if (type === LocationType.WAREHOUSE) {
        return <Warehouse fontSize="medium" color={color} />;
      }
      
      return <LocationOn fontSize="medium" color={"error"} />;
    };
    
    return (
      <Box
        onClick={onClick}
        sx={{ 
          width: logoUrl ? 32 : 24, 
          height: logoUrl ? 32 : 24, 
          cursor: "pointer", 
          overflow: "visible" 
        }}
      >
        <Tooltip title={label} placement="top" arrow>
          <span>
            {renderIcon()}
          </span>
        </Tooltip>
  
        {/* Source handles */}
        <Handle type="source" position={Position.Bottom} id={`source-bottom`} style={{ opacity: 0, width: 0, height: 0, left: "50%", transform: "translateX(-50%)", bottom: 5 }} />
        <Handle type="source" position={Position.Left}   id={`source-left`}   style={{ opacity: 0, width: 0, height: 0, left: 5,  top: "50%", transform: "translateY(-50%)" }} />
        <Handle type="source" position={Position.Right}  id={`source-right`}  style={{ opacity: 0, width: 0, height: 0, right: 5, top: "50%", transform: "translateY(-50%)" }} />
        <Handle type="source" position={Position.Top}    id={`source-top`}    style={{ opacity: 0, width: 0, height: 0, top: 5,   left: "50%", transform: "translateX(-50%)" }} />
       
  
        {/* Target handles */}
        <Handle type="target" position={Position.Bottom} id={`target-bottom`} style={{ opacity: 0, width: 0, height: 0, left: "50%", transform: "translateX(-50%)", bottom: 5 }} />
        <Handle type="target" position={Position.Left}   id={`target-left`}   style={{ opacity: 0, width: 0, height: 0, left: 5,  top: "50%", transform: "translateY(-50%)" }} />
        <Handle type="target" position={Position.Right}  id={`target-right`}  style={{ opacity: 0, width: 0, height: 0, right: 5, top: "50%", transform: "translateY(-50%)" }} />
        <Handle type="target" position={Position.Top}    id={`target-top`}    style={{ opacity: 0, width: 0, height: 0, top: 5,   left: "50%", transform: "translateX(-50%)" }} />
      </Box>
    );
  };